/** 团队成员展示字段（接口/UserInfo/globalStore.User 字段不完全一致） */
export type UserDisplayFields = {
  userName?: string | null;
  nickname?: string | null;
  nickName?: string | null;
  realName?: string | null;
  name?: string | null;
  userAvatar?: string | null;
  avatarUrl?: string | null;
};

export function displayUserName(user?: UserDisplayFields | null): string {
  if (!user) {
    return '';
  }
  const name =
    user.nickname ??
    user.nickName ??
    user.realName ??
    user.userName ??
    user.name ??
    '';
  return String(name).trim();
}

export function displayUserAvatar(user?: UserDisplayFields | null): string | undefined {
  if (!user) {
    return undefined;
  }
  const avatar = user.userAvatar ?? user.avatarUrl;
  return avatar ? String(avatar) : undefined;
}
